<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-row v-if="windowWidth > 950 && isDashboardPermission" vs-type="flex" vs-w="12">
      <dashboard-default @reloadStockOrders="getStockOrdersForDashboard && isDashboardPermission" :dataSet="dataSet" @fetchData="fetchData" @branchChanged="onBranchChanged" />
    </vs-row>
    <vs-row v-else-if="isDashboardPermission" vs-type="flex" vs-w="12">
      <dashboard-mobil :windowsSize="windowWidth" :dataSet="dataSet" @fetchData="fetchData" />
    </vs-row>
  </vs-row>
</template>

<script>
  import {
    GetProductGiro,
    GetProductGiroForDealer,
    GetCategoryGiro,
    GetCategoryGiroForDealer,
    GetPaymentReport,
    GetPaymentReportForDealer,
    GetTotalsOfSales,
    GetBranchGiro,
    GetBranchGiroForDealer,
    GetBranchPersonalGiro,
    GetGiroByTime,
    GetGiroByTimeForDealer,
    GetGiroByDate,
    GetGiroByDateForDealer,
    GetTargetsForDashboard,
    GetStockOrdersForDashboard,
    GetTotalsOfSalesForDealer
  } from "@/api/Reports.js";
  import {
    getBranchNameList
  } from "@/api/User.js"
  import {
    getDashboardTimeRanges,
    getDashboardProps
  } from "@/model/constants/dashboardModels.js";
  import DashboardDefault from './DashboardDefault.vue';
  import DashboardMobil from "./DashboardMobile.vue";
  import {isGranted} from "@/utils/auth";
  import { getNotifications, readNotifications } from "@/api/UserWant";
  export default {
    data() {
      return {
        windowWidth: 0,
        branches: [],
        byBranch: {
          payments: [],
          totalsOfSales: {},
          branchGiros: [],
          personalGiros: []
        },
        byCategory: [],
        byDate: {},
        byHour: {},
        byProduct: [],
        stockOrders: [],
        targets: [],
        timeRanges: [],
        reportProps: [],
        isBranchOrPersonal: true,
      }
    },
    components: {
      DashboardDefault,
      DashboardMobil
    },
    computed: {
      isDashboardPermission(){
      return isGranted("main_dashboard")
    },
      dataSet() {
        return {
          branches: this.branches,
          byBranch: {
            payments: this.byBranch.payments,
            totalsOfSales: this.byBranch.totalsOfSales,
            branchGiros: this.byBranch.branchGiros,
            personalGiros: this.byBranch.personalGiros,
          },
          byCategory: this.byCategory,
          byDate: this.byDate,
          byHour: this.byHour,
          byProduct: this.byProduct,
          stockOrders: this.stockOrders,
          targets: this.targets,
          timeRanges: this.timeRanges,
          reportProps: this.reportProps,
          isBranchOrPersonal: this.isBranchOrPersonal,
        }
      }
    },
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      onBranchChanged(val) {
        this.getTargetsForDashboard(val.id);
        this.getStockOrdersForDashboard(val.id);
      },
      getBranchNameList: function () {
        getBranchNameList().then(res => {
          if (res && res.status === 200) {
            this.branches = res.data;
            this.branches.unshift({
              id: null,
              name: "Tüm Şubeler"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Listesi Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      getProductGiro(tableOptions) {
        if (this.$isRegionalCenterBranch()) {
          GetProductGiroForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byProduct = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ürün Raporu Yüklenemedi !'
            });
          }
        }).catch((err) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }else{
        GetProductGiro(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byProduct = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ürün Raporu Yüklenemedi !'
            });
          }
        }).catch((err) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      }
      },
      getCategoryGiro(tableOptions) {
        if (this.$isRegionalCenterBranch()) {
          GetCategoryGiroForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byCategory = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategori Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }else{
          GetCategoryGiro(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byCategory = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategori Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
        
      },
      getGiroByDate(tableOptions) {
        if (this.$isRegionalCenterBranch()) {
          GetGiroByDateForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byDate = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Gün Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }else{
          GetGiroByDate(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byDate = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Gün Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
        
      },
      getGiroByTime(tableOptions) {
        if (this.$isRegionalCenterBranch()) {
          GetGiroByTimeForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byHour = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Saat Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }else{
          GetGiroByTime(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byHour = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Saat Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
        
      },
      getBranchGiro(tableOptions) {
        if (this.$isCenterBranch()) {
          GetBranchGiro(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.branchGiros = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Şubeler Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }if (this.$isRegionalCenterBranch()) {
          GetBranchGiroForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.branchGiros = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Şubeler Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
        
      },
      getBranchPersonalGiro(tableOptions) {
        GetBranchPersonalGiro(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.personalGiros = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategori Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      },
      getTotalsOfSales(tableOptions) {
        if (this.$isCenterBranch) {
          GetTotalsOfSales(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.totalsOfSales = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Genel Toplamlar Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }if (this.$isRegionalCenterBranch()) {
          GetTotalsOfSalesForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.totalsOfSales = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Genel Toplamlar Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
       
      },
      getNotifications(){
        getNotifications().then(res => {
          console.log(res.data);
          if(res.data.length > 0){
            this.$vs.notify({
              sticky: true,
              color: 'danger',
              position: 'top-right',
              title: 'İletişim sisteminde ' + res.data.length + ' adet yeni istek var.',
              text: 'Tıklayarak bu istekleri görüntüleyebilirsiniz.',
              clickClose: true,
              time: 999999,
              click: () => {
                console.log('click notification');
                // Add your desired click action here
                // For example, navigate to the notifications page:
                readNotifications();
                 this.$router.push('/pages/userwant');
              }
            })
          }
        })
      },
      getPaymentReport(tableOptions) {
        if (this.$isRegionalCenterBranch() && !this.$isCenterBranch()) {
          GetPaymentReportForDealer(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.payments = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ödeme Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }else{
          GetPaymentReport(tableOptions).then(res => {
          if (res && res.status == 200) {
            this.byBranch.payments = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ödeme Raporu Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
        }
        
      },
      getTargetsForDashboard(id) {
        GetTargetsForDashboard(id).then(res => {
          if (res && res.status == 200) {
            this.targets = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Hedefler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      },
      getStockOrdersForDashboard(id) {
        GetStockOrdersForDashboard(id).then(res => {
          if (res && res.status == 200) {
            this.stockOrders = [];
            this.stockOrders = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Siparişler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      },
      fetchData(tableOptions) {
        if ((this.$isCenterBranch()||this.$isRegionalCenterBranch()) && (!tableOptions.branch || !tableOptions.branch.id)) {
          this.getBranchGiro(tableOptions);
          this.isBranchOrPersonal = true;
        } else {
          this.getBranchPersonalGiro(tableOptions);
          this.isBranchOrPersonal = false;
        }
        this.getProductGiro(tableOptions);
        this.getCategoryGiro(tableOptions);

        if (tableOptions.defaultTimeRange.id != 0) this.getGiroByDate(tableOptions);
        this.getGiroByTime(tableOptions);
        this.getPaymentReport(tableOptions);
        this.getTotalsOfSales(tableOptions);
        this.getNotifications();
      }
    },
    beforeMount() {
      this.timeRanges = getDashboardTimeRanges();
      this.reportProps = getDashboardProps();
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      this.getBranchNameList();
      this.getTargetsForDashboard();
      this.getStockOrdersForDashboard();
    }
  }

</script>

<style>

</style>
